import { v4 as uuid } from "uuid";

import { IClassroomResource } from "../../classrooms";
import { EntityTypes } from "../../EntityTypes";
import { ILanguageResource } from "../../languages";
import { UserRole } from "../../users";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValueAsIRI, RelationalValue } from "../../utils/filters";
import { AnnouncementStatus, IAnnouncementResource } from "../types";

export type IAnnouncementCreateMutationParameters = {
    uuid?: string;
    language: RelationalValue<ILanguageResource>;
    title: string;
    body: string;
    appearanceDate: string;
    videoUrl?: string | null;
    targetRoles: UserRole[];
    targetClassrooms: RelationalValue<IClassroomResource>[];
    status: AnnouncementStatus;
};

export type IAnnouncementCreateMutationResult = IAnnouncementResource;

export const announcementCreateMutation: IApiMutationFunction<IAnnouncementCreateMutationParameters> = ({
    uuid: providedUuid,
    language,
    title,
    body,
    appearanceDate,
    videoUrl,
    targetRoles,
    targetClassrooms,
    status,
}) => ({
    method: "POST",
    url: "/announcements",
    data: {
        uuid: providedUuid ?? uuid(),
        language: mapRelationalValueAsIRI(EntityTypes.LANGUAGE, language),
        title,
        body,
        appearanceDate,
        videoUrl,
        targetRoles,
        targetClassrooms: targetClassrooms.map(classroom => mapRelationalValueAsIRI(EntityTypes.CLASSROOM, classroom)),
        status,
    },
});

export const useAnnouncementCreateMutation = createApiMutationHook<
    IAnnouncementCreateMutationParameters,
    IAnnouncementCreateMutationResult
>(announcementCreateMutation);
